export const getCatTagPageLink = (routePath: string, tag = '') => {
  return `${routePath}/${tag
    .replace('&', '')
    .replace(/\s+/g, '-')
    .toLowerCase()}-jobs`;
};
